export const VIDEO_QUALITY = {
    "360": { label: "360" },
    "480": { label: "480" },
    "720": { label: "720" },
    "1080": { label: "1080" },
};
